<template>
	<div>
		<div class="empty-text" v-if="data.length==0">暂无数据...</div>
		<div class="me-lesson">
			<ul class="me-lesson-items" v-dt-infinite-scroll="getData">
				<!--<li class="me-lesson-item">
					<div class="me-lesson-main f-cb">
						<div class="me-lesson-pic f-img-box">
							<img src="../index/collection-pic.png">
							<div class="me-lesson-pic-text">6天后到期</div>
						</div>
						<div class="me-lesson-content">
							<div class="me-lesson-title o1">Axure入门</div>
							<div class="me-lesson-place">天津文化馆</div>
							<div class="me-lesson-info f-cb">
								<div class="me-lesson-last">上次学习 2018.8.10</div>
								<div class="me-lesson-rate">已学 56%</div>
							</div>
						</div>
					</div>
					<div class="me-lesson-ops">
						<div class="me-lesson-comment">评价</div>
						<div class="me-lesson-cancel">取消报名</div>
					</div>
				</li>-->
				<li class="me-lesson-item" v-for="item in data">
					<div class="me-lesson-main f-cb" @click="$router.push('/lesson-detail/'+item.id)">
						<div class="me-lesson-pic f-img-box">
							<img :src="item.cover_img">
							<div class="me-lesson-pic-text">{{item.end_time!=0 ? tools.timestampToText(item.end_time)+"后到期" : "无期限"}}</div>
						</div>
						<div class="me-lesson-content">
							<div class="me-lesson-title o1">{{item.course_title}}</div>
							<div class="me-lesson-place">{{item.teacherNickName}}</div>
							<div class="me-lesson-info f-cb">
								<div class="me-lesson-last">上次学习 {{tools.timestampConversion(item.last_stu_time)}}</div>
								<div class="me-lesson-rate">已学 {{item.schedule}}</div>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				data:[]
			}
		},
		methods:{
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/user/taCourse",
						user_type:1,
						user_id:this.$route.params.id,
						page,
						len:5
					},res=>{
						var data=res.data;
						this.data=this.data.concat(data);
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
					})
				})
			}
		},
		created(){
			
		}
	}
</script>

<style>
	.me-lesson-item{
		padding:0.533rem 0 0 0;
	}
	.me-lesson-main{
		padding:0.266rem 0.4rem;
		background: #eee;
	}
	.me-lesson-pic{
		position: relative;
		float:left;
		width:2.88rem;
		height:2.106rem;
		border-radius: 0.133rem;
	}
	.me-lesson-pic-text{
		position: absolute;
		bottom:0;
		left:0;
		height:0.666rem;
		line-height:0.666rem;
		text-align: center;
		font-size: 0.346rem;
		color:#fff;
		width:100%;
		background:rgba(0,0,0,0.5);
	}
	.me-lesson-content{
		float:right;
		width:6rem;
	}
	.me-lesson-title{
		margin-top:0.133rem;
		color:#333;
		font-size: 0.426rem;
	}
	.me-lesson-place{
		margin-top:0.2rem;
		font-size: 0.346rem;
		color:#999;
	}
	.me-lesson-info{
		margin-top:0.466rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.me-lesson-last{
		float:left;
	}
	.me-lesson-rate{
		float: right;
	}
	.me-lesson-ops{
		margin:0.4rem 0.4rem 0 0.4rem;
		padding-bottom: 0.4rem;
		height:0.693rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.me-lesson-comment{
		float:right;
		box-sizing: border-box;
		width:2.186rem;
		height:0.693rem;
		margin-right: 0.4rem;
		border:1px solid #999999;
		text-align: center;
		line-height:0.693rem;
		color:#666;
		border-radius: 0.133rem;
	}
	.me-lesson-cancel{
		float:right;
		margin-right: 0.586rem;
		line-height:0.693rem;
		color:#ccc;
	}
</style>


// WEBPACK FOOTER //
// src/components/other-lesson/other-lesson.vue